import { render, staticRenderFns } from "./multifile.vue?vue&type=template&id=ec385ca4&"
import script from "./multifile.vue?vue&type=script&lang=js&"
export * from "./multifile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports